<template>
  <div class="bg-gray-100">
    <header class="bg-white border-b-2 border-gray-300 p-4">
      <h1 class="text-2xl font-bold text-gray-800">
        PushHike Incident Response Policy
      </h1>
    </header>

    <main class="container mx-auto py-8 px-4">
      <section>
        <h2 class="text-xl font-bold text-gray-800 mt-4">Purpose</h2>
        <p class="mt-2">
          The purpose of this incident response policy is to provide a framework
          for identifying, assessing, and responding to security incidents
          related to the PushHike Shopify app. This policy is intended to
          minimize the impact of security incidents and ensure that PushHike's
          customers are notified of any relevant issues in a timely and
          transparent manner.
        </p>
      </section>

      <section>
        <h2 class="text-xl font-bold text-gray-800 mt-4">Scope</h2>
        <p class="mt-2">
          This incident response policy applies to all employees, contractors,
          and partners who work with or have access to PushHike's systems or
          data. This policy covers security incidents related to the PushHike
          Shopify app, including but not limited to:
        </p>
        <ul class="list-disc mt-2 ml-6">
          <li>Unauthorized access to customer data</li>
          <li>Malware or other malicious code</li>
          <li>Denial of service attacks</li>
          <li>Data breaches</li>
        </ul>
      </section>

      <section>
        <h2 class="text-xl font-bold text-gray-800 mt-4">
          Roles and Responsibilities
        </h2>
        <p class="mt-2">
          PushHike's incident response team is responsible for implementing and
          enforcing this incident response policy. The incident response team
          consists of:
        </p>
        <ul class="list-disc mt-2 ml-6">
          <li>The CEO</li>
          <li>The CTO</li>
          <li>The lead developer</li>
          <li>The lead customer support representative</li>
        </ul>
        <p class="mt-2">
          In the event of a security incident, the incident response team will
          be responsible for coordinating the response and communicating with
          all relevant parties.
        </p>
      </section>

      <section>
        <h2 class="text-xl font-bold text-gray-800 mt-4">
          Incident Response Procedures
        </h2>

        <ol class="list-decimal mt-2 ml-6">
          <li class="mt-2">Identify and Contain the Incident</li>
          <p class="mt-2">
            Upon discovery of a security incident related to the PushHike
            Shopify app, the incident response team will take immediate steps to
            contain the incident and prevent further damage. This may include
            shutting down affected systems, isolating compromised data, or
            blocking unauthorized access.
          </p>

          <li class="mt-2">Assess the Impact</li>

          <p class="mt-2">
            Once the incident has been contained, the incident response team
            will assess the impact of the incident to determine the extent of
            the damage and the potential risks to PushHike's customers. This may
            involve analyzing system logs, conducting forensic investigations,
            or consulting with outside experts.
          </p>
          <li class="mt-2">Notify Relevant Parties</li>
          <p class="mt-2">
            If the incident poses a risk to PushHike's customers or their data,
            the incident response team will notify all affected customers in a
            timely and transparent manner. This may involve sending email
            notifications, posting alerts on PushHike's website, or contacting
            customers directly.
          </p>
          <li class="mt-2">Remediate and Recover</li>
          <p class="mt-2">
            The incident response team will work to remediate any damage caused
            by the incident and restore affected systems to their normal state.
            This may involve patching vulnerabilities, restoring data from
            backups, or implementing new security controls.
          </p>
          <li class="mt-2">Review and Improve</li>
          <p class="mt-2">
            After the incident has been resolved, the incident response team
            will conduct a review of the incident response procedures to
            identify any areas for improvement. This may involve updating
            policies and procedures, enhancing security controls, or providing
            additional training to employees.
          </p>
        </ol>
      </section>
      <section>
        <h2 class="text-xl font-bold text-gray-800 mt-4">
          Conclusion
        </h2>
        <p class="mt-2">
          PushHike is committed to protecting the security and privacy of our
          customers' data. This incident response policy provides a framework
          for responding to security incidents related to the PushHike Shopify
          app in a timely and effective manner. By following these procedures,
          we can minimize the impact of security incidents and maintain the
          trust of our customers.
        </p>
      </section>
    </main>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
